var sliderThumbnail = new Swiper(".thumbnail--list", {
  slidesPerView: 4,
  freeMode: true,
  spaceBetween: 20,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var slider = new Swiper(".product__media-list", {
  navigation: {
    prevEl: ".swiper--button--prev",
    nextEl: ".swiper--button--next",
  },
  spaceBetween: 5,
  autoHeight: true,
  thumbs: {
    swiper: sliderThumbnail,
  },
});

new Swiper(".review_box_row", {
  slidesPerView: 6.82,
  spaceBetween: 20,
  speed: 500,
  pagination: {
    el: ".slider__pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".slider__button-next",
    prevEl: ".slider__button-prev",
  },
  breakpoints: {
    1399: {
      slidesPerView: 5.5,
      spaceBetween: 18,
    },
    989: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    749: {
      slidesPerView: 2.5,
      spaceBetween: 16,
    },
    575: {
      slidesPerView: 1.5,
      spaceBetween: 16,
    },
    0: {
      slidesPerView: 1.17,
      spaceBetween: 16,
    },
  },
});

new Swiper(".golden-spirit", {
  slidesPerView: 6.82,
  spaceBetween: 20,
  speed: 500,
  pagination: {
    el: ".slider__pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".slider__button-next",
    prevEl: ".slider__button-prev",
  },
  breakpoints: {
    1399: {
      slidesPerView: 5.5,
      spaceBetween: 18,
    },
    989: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    749: {
      slidesPerView: 2.5,
      spaceBetween: 16,
    },
    575: {
      slidesPerView: 1.9,
      spaceBetween: 10,
    },
    0: {
      slidesPerView: 1.72,
      spaceBetween: 10,
    },
  },
});

document
  .querySelectorAll(".section-image-banner .button")
  .forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var attr = this.getAttribute("href").replace("#", "");
      console.log(attr);
      var target = document.querySelector('section[id="' + attr + '"]');

      if (target) {
        window.scrollTo({
          top: target.offsetTop - 107,
          behavior: "smooth",
        });
      }
    });
  });
